module.exports = __webpack_public_path__ + "static/media/weekly_assignment.f10ae653.png";